define('views/modules/calendar/personal-data/item/personal-data-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    'services/i18n',
    'services/user',
    'services/toastr-service',
    //collections
    'collections/calendar/personal-data/personal-data-types',
    // parts views
    'views/parts/alert/alert-list',
    // Views
    'views/modules/calendar/calendar-item-panel-content',
    'views/modules/calendar/personal-data/item/form/personal-data-details-form',
    // Templates Blocks
    'text!templates/modules/calendar/personal-data/item/personal-data-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U, i18n, User, ToastrService,
    //collections
    CPersonalDataType,
    // parts views
    VAlertList,
    // Views
    VCalendarItemPanelContent,
    VPersonalDataDetailsForm,
    // Template
    TPersonalDataDetails
) {

    var VPersonalDataDetails = VCalendarItemPanelContent.extend({
        contentTemplate: TPersonalDataDetails,
        fields: VCalendarItemPanelContent.prototype.fields.concat(['customData', 'value', 'name', 'unit']),

        regions: _.extend({}, VCalendarItemPanelContent.prototype.regions, {
            details: ".personal-data-details-form",
            alert: ".personal-data-alert",
        }),

        initialize: function(opt) {
            VPersonalDataDetails.__super__.initialize.call(this, opt);
            this.view.alert = new VAlertList({ dismissable: false });

            var view = _.extend(this.view, {
                details: new VPersonalDataDetailsForm({ model: this.model }),
            });
        },

        render: function() {
            VPersonalDataDetails.__super__.render.call(this);
            if (!this.SetUserInputRight()) { //On ne genere pas le formulaire
                this.assign(this.view.details, this.zone.$details);
            }
            this.renderAlertView();
            this.view.alert.reset();

            if (this.userCanSeeAlert()) {
                this.view.alert.addInfo(i18n.t('calendar:this-item-is-hidden'));
            }

            return this;
        },

        userCanSeeAlert: function() {
            if (! User.getSupervisorGroup().daysBeforeCalendarItemsAreHidden || this.model.isNew() || this.model.get('isVisible')) {
                return false;
            }

            return this.model.isAfterDays(User.getSupervisorGroup().daysBeforeCalendarItemsAreHidden);
        },

        renderAlertView: function() {
            if (this.view.alert) {
                this.assign(this.view.alert, this.zone.$alert);
            }
            return this;
        },

        onInvalid: function() {
            if (!this.view.alert) {
                this.view.alert = new VAlertList();
                this.renderAlertView();
            }

            this.view.alert.reset();

            _.each(this.model.validationError, function(errors) {
                this.view.alert.addError(errors);
            }, this);
        },

        onSave: function() {
          if (this.model.get('customData') === null) {
              this.view.alert.reset();
              this.view.alert.addError('api-messages:INVALID_OBJECTID');
          }
        },

        SetUserInputRight: function() {
            var disableForm = false;
            if (this.model.get("customData")) {
                if (this.options.role === "client") {
                  var colCustomDatas = new CPersonalDataType();
                  colCustomDatas.fetch({ async: false });
                  var cusData = colCustomDatas.where({ _id: this.model.get("customData") });

                  if (cusData.length === 0) { //Si undefined, member_entry = false
                    disableForm = true;
                    if (!this.view.alert) {
                        this.view.alert = new VAlertList();
                    }
                    this.renderAlertView();
                    this.view.alert.reset();
                    this.view.alert.addError(i18n.t('calendar:Your trainer is the only one who can enter or edit a value for this custom data'));
                  }
                }
              }
            return disableForm;
        }

    });

    return VPersonalDataDetails;

});

